import { DeviceDetectionUtils } from './deviceDetection';

const UNIVERSAL_LINK = `https://netbroker.erstemarket.hu/app`;
const APP_STORE_URL = 'https://apps.apple.com/app/id6751633597';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=hu.netbroker.app';

const getStoreUrl = (): string => {
  const platform = DeviceDetectionUtils.getMobilePlatform();

  if (platform === 'ios') {
    return APP_STORE_URL;
  }

  if (platform === 'android') {
    return PLAY_STORE_URL;
  }

  return PLAY_STORE_URL;
};

export const getMobileAppLink = (): string => UNIVERSAL_LINK;

export const getMobileAppStoreLink = (): string => getStoreUrl();
